// reducer.js
export interface SubDepartment {
  id: number;
  created_at: string;
  updated_at: string;
  created_by_id: null;
  updated_by_id: null;
  name: string;
  code: null;
  department_id: number;
}
export interface Department {
  id: number;
  created_at: string;
  updated_at: string;
  created_by_id: null;
  updated_by_id: null;
  name: string;
  code: null;
  sub_departments: SubDepartment[];
}

export interface DepartmentState {
  data: Department[];
  error: string | null;
}

export interface Action {
  type: string;
  payload: any;
}

const departmentinitialState: DepartmentState = {
  data: [],
  error: null,
};

export const departmentReducer = (
  state: DepartmentState = departmentinitialState,
  action: Action
): DepartmentState => {
  switch (action.type) {
    case "FETCH_DEPARTMENT_SUCCESS":
      return { ...state, data: action.payload };
    case "FETCH_DEPARTMENT_ERROR":
      return { ...state, error: action.payload };
    default:
      return state;
  }
};
